module.exports = __webpack_public_path__ + "img/71fbc22bf17e5c078d70c771471579d6.9777f002.png";